const IconCornerDownRight = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill={props.fill}
      stroke={props.stroke}
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.33301 3.33301V4.49967C3.33301 7.29994 3.33301 8.70007 3.87798 9.76963C4.35734 10.7104 5.12224 11.4753 6.06306 11.9547C7.13261 12.4997 8.53275 12.4997 11.333 12.4997H16.6663M16.6663 12.4997L12.4997 8.33301M16.6663 12.4997L12.4997 16.6663"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default IconCornerDownRight
